export default __webpack_public_path__ + "static/media/SilverActive.988762b6.svg";